import { NAMESPACE } from './reducer';
import { State } from './types';

type GlobalState = {
    [key in typeof NAMESPACE]: State;
}

export const getCart = (state: GlobalState) => state[NAMESPACE].cart;

